<template>
  <div :class="[deviceType, 'inner']">
    <p>{{ prop.selectedCard.cardName }}</p>
    <div class="content">
      <div class="cardBox">
        <img
          :class="[deviceType, 'cardImage']"
          :src="'data:image/png;base64,' + prop.selectedCard.image"
        />
      </div>
      <div class="popup-sign">
        <AcknowledgementDeclinedSvg></AcknowledgementDeclinedSvg>
      </div>
    </div>
  </div>

  <div class="top-up-successful">
    {{ t("ccOnBoarding.cardListing.unsuccessful") }}
  </div>
  <div :class="[deviceType, 'wallet-limit-up-to-m']">
    {{ t("ccOnBoarding.cardListing.cardRemark") }}
  </div>

  <p :class="[deviceType, 'unsucessful-card-header']">
    {{ t("ccOnBoarding.cardListing.title") }}
  </p>
  <p :class="[deviceType, 'desc']" style="font-size: 16px">
    {{ t("ccOnBoarding.cardListing.recommendation2") }}
  </p>
  <div :class="[deviceType, 'cards']">
    <div
      class="singleCard"
      v-for="card in cards"
      :class="{ 'card-selected': card.selected }"
      @click="toggleSelected(card)"
    >
      <div class="cardImgBox">
        <img class="cardImage" :src="'data:image/png;base64,' + card.image" />
      </div>
      <p class="cardName">{{ card.cardName }}</p>
      <div style="margin-bottom: 20px">
        <div class="infoBox">
          <div
            class="cardInfo"
            v-for="(info, index) in card.cardInfo"
            :key="index"
          >
            <img
              style="width: 6.9px; height: 13px"
              class="path-65"
              src="../../../../assets/icons/tick.svg"
            />
            <p>{{ info }}</p>
          </div>
        </div>
      </div>

      <!-- <div class="cardSelected-div">
        <p class="cardSelected">{{ t("ccOnBoarding.cardListing.selected") }}</p>
      </div> -->

      <!-- <button :class="[deviceType, 'findOut-button']">
        {{ t("ccOnBoarding.cardListing.findOutMore") }}
        <img
          style="width: 23px; height: 30px"
          class="path-65"
          src="../../../../assets/icons/Arrow_right.svg"
        />
      </button> -->
    </div>
  </div>
  <div :class="[deviceType, 'buttoncontainer']">
    <div :class="[deviceType, 'left-button']" @click="back()">
      {{ t("ccOnBoarding.back") }}
    </div>
    <button
      :class="[deviceType, 'right-button']"
      :disabled="isBtnDisabled"
      @click="jump()"
    >
      {{ t("ccOnBoarding.next") }}
    </button>
  </div>
</template>

<script setup lang="ts">
import {
  ref,
  onMounted,
  computed,
  onBeforeMount,
  type PropType,
  watch,
} from "vue";

import i18n from "@/plugin/i18n";
import MasterService from "@/service/restfulService/CCOnboardMasterService";
import { deviceDetect } from "mobile-device-detect";
import { inject } from "vue";
import AcknowledgementDeclinedSvg from "@/assets/icons/AcknowledgementDeclinedSvg.vue";
import type { Card } from "@/interface/FormCC";

const cards = ref<Card[]>([]);

const toggleSelected = (selectedCards: any) => {
  cards.value.forEach((card) => {
    if (card === selectedCards) {
      if (selectedCards.selected == true) card.selected = false;
      else card.selected = true;
    } else {
      card.selected = false;
    }
  });
};

const deviceType = inject("deviceType");

if (deviceType == "d") {
}
const { t } = i18n.global;

const eligibility = ref(true);
const prop = defineProps({
  selectedCard: {
    type: Object as PropType<Card>,
    required: true,
  },
  type: {
    type: String,
  },
  nationality: {
    type: String,
  },
  grossSalary: {
    type: Number,
  },
  webFormRequestId: {
    type: String,
  },
  token: {
    type: String,
    required: true,
  },
  acc: {
    type: String,
  },
});

//List
const titleList = ref([]);
const relationshipList = ref([]);
const mobileCountryCodeList = ref([]);

onBeforeMount(() => {
  MasterService.getMasterData()
    .then((res) => {
      titleList.value = res.data.titleType;
      relationshipList.value = res.data.relativeType;
      mobileCountryCodeList.value = res.data.mobileNoCountryCode;
    })
    .catch((e) => {});

  const requestModel = {
    applicationChannel: prop.acc,
    nationality: prop.nationality,
    grossSalary: prop.grossSalary,
    type: prop.type,
  };

  MasterService.cardValidate(requestModel)
    .then((res) => {
      for (let i = 0; i < res.data.responseModel.cardList.length; i++) {
        cards.value.push({
          image: res.data.responseModel.cardList[i].cardImage,
          cardName: res.data.responseModel.cardList[i].cardDesc,
          cardInfo: res.data.responseModel.cardList[i].cardDesc2,
          cardId: res.data.responseModel.cardList[i].cardCode,
          selected: false,
          nationality: res.data.responseModel.cardList[i].nationality,
          minAge: res.data.responseModel.cardList[i].minAge,
          minSalary: res.data.responseModel.cardList[i].minSalary,
          defaultCard: res.data.responseModel.cardList[i].defaultCard,
        });
      }
      if (cards.value.length > 0) emit("closeOverlay");
    })
    .catch((e) => {});
});

const schema = computed(() => {
  return true;
});

const onInvalidSubmit = () => {};

const isBtnDisabled = computed(() => {
  return cards.value.findIndex((x) => x.selected) < 0;
});

const emit = defineEmits([
  "nextStep",
  "jumpStep",
  "submit",
  "setCardId",
  "closeOverlay",
  "setCardName",
  "tokenSessionTimeOut",
]);
const onSubmit = () => {
  emit("submit");
};

// const handleBack = () => {
//   emit("previousStep");
// };

const jump = () => {
  cards.value.forEach((card) => {
    if (card.selected == true) {
      prop.selectedCard.cardId = card.cardId;
      prop.selectedCard.cardInfo = card.cardInfo;
      prop.selectedCard.cardName = card.cardName;
      prop.selectedCard.image = card.image;
      prop.selectedCard.minAge = card.minAge;
      prop.selectedCard.nationality = card.nationality;
      prop.selectedCard.selected = card.selected;
    }
  });
  emit("setCardId");
  emit("setCardName");
  // update card Id
  if (prop.webFormRequestId != "") {
    const cardSubmissionRequestModel = {
      webFormRequestId: prop.webFormRequestId,
      cardId: prop.selectedCard.cardId,
    };
    MasterService.cardSubmission(cardSubmissionRequestModel, prop.token)
      .then((res) => {
        if (res.status == 200) {
          if (prop.type == "MC") {
            // Get the current URL
            const currentUrl = window.location.href;

            // Create a URL object
            const url = new URL(currentUrl);

            // Update the CPC parameter
            url.searchParams.set("CPC", prop.selectedCard.cardId);

            // Use replaceState to change the URL without reloading the page
            window.history.replaceState({}, "", url.toString());
          } else if (prop.type == "BIO") {
            // Get the current URL
            const currentUrl = window.location.href;

            // Create a URL object
            const url = new URL(currentUrl);

            // Update the CPC parameter
            url.searchParams.set("cc", prop.selectedCard.cardId);

            // Use replaceState to change the URL without reloading the page
            window.history.replaceState({}, "", url.toString());
          } else
            window.history.replaceState(
              null,
              "",
              "?cc=" + prop.selectedCard.cardId,
            );
          emit("jumpStep", 1, "", 4);
        }
      })
      .catch((e) => {
        if (e.response && e.response.data.code == "WB-401") {
          // EndSession
          emit("tokenSessionTimeOut");
        }
      });
  } else {
    if (prop.type == "MC") {
      // Get the current URL
      const currentUrl = window.location.href;

      // Create a URL object
      const url = new URL(currentUrl);

      // Update the CPC parameter
      url.searchParams.set("CPC", prop.selectedCard.cardId);

      // Use replaceState to change the URL without reloading the page
      window.history.replaceState({}, "", url.toString());
    } else if (prop.type == "BIO") {
      // Get the current URL
      const currentUrl = window.location.href;

      // Create a URL object
      const url = new URL(currentUrl);

      // Update the CPC parameter
      url.searchParams.set("cc", prop.selectedCard.cardId);

      // Use replaceState to change the URL without reloading the page
      window.history.replaceState({}, "", url.toString());
    } else
      window.history.replaceState(null, "", "?cc=" + prop.selectedCard.cardId);
    emit("jumpStep", 1, "", 4);
  }
};

const back = () => {
  emit("jumpStep", 1, "", 4);
};

const handleNameKeyDown = (event: KeyboardEvent) => {
  const isSymbol = /^[a-zA-Z@#()_:\/.,'\-\s]+$/.test(event.key);
  const isDeleteKey = event.key === "Delete";
  const isBackspace = event.key === "Backspace";
  const isTabKey = event.key === " Tab";
  const isArrowKey = /^Arrow(Left|Right)$/.test(event.key);

  const isIOSArrowKey =
    event.key === "UIKeyInputLeftArrow" || event.key === "UIKeyInputRightArrow";
  const isAndroidArrowKey =
    event.key === "ArrowLeft" || event.key === "ArrowRight";

  if (
    !isSymbol &&
    !isBackspace &&
    !(isArrowKey || isIOSArrowKey || isAndroidArrowKey) &&
    !isDeleteKey &&
    !isTabKey
  ) {
    event.preventDefault();
  }
};

const handleEnterKey = () => {};
</script>
<style scoped>
/* .content {
    display: flex;
    margin-top: 40px;
    padding: 0 8%;
  } */

.container {
  display: flex;
  width: 100%;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  padding: 0;
  margin-bottom: 14px;
}

.flex_half {
  width: 50%;
}

.separator {
  margin-bottom: 37px;
  border-bottom: 1px solid #e4e4e4;
}

.flex_dropdown {
  display: flex;
  width: 30%;
  box-sizing: border-box;
  position: relative;
  display: inline-block;
}

.flex_inputText {
  width: 70%;
}

.right-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}

.left-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: 1px solid #cb03bc;
  background-color: white;
  font-size: 14px;
  font-weight: 500;
  color: #cb03bc;
  text-align: center;
  flex: 0 0 25%;
  cursor: pointer;
}

.right-button:disabled {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background: #dedede;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}

.full {
  width: 100%;
}

.line {
  border-bottom: 1px solid #e4e4e4;
}

.buttoncontainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
}

.left-button {
  flex: 0 0 15%;
}

.agree {
  display: flex;
  align-items: flex-start;
}

.flex_third {
  width: 30%;
}

.container3 {
  display: flex;
  width: 100%;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  padding: 0;
  margin-bottom: 14px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 110%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  will-change: transform, opacity;
  transform: translateZ(0);
  overflow-y: hidden;
  transition: top 0.3s;
}
.loading {
  margin-bottom: 0;
  font-family: "Outfit";
  color: white;
}
.spinner-border {
  width: 5rem;
  height: 5rem;
  color: white;
}
.flex-container {
  left: 0;
  margin: auto;
  position: absolute;
  text-align: center;
  top: 35%;
  right: 30%;
  left: 30%;
}

@media (max-width: 700px) {
  .container:is(.Desktop, .Tablet),
  .container3:is(.Desktop, .Tablet) {
    flex-direction: column;
    gap: 14px;
  }

  .flex_dropdown:is(.Desktop, .Tablet),
  .flex_inputText:is(.Desktop, .Tablet) {
    width: 100%;
  }
  .flex_half:is(.Desktop, .Tablet) {
    width: 100%;
  }

  .buttoncontainer:is(.Desktop, .Tablet) {
    gap: 10px;
  }

  .left-button:is(.Desktop, .Tablet) {
    flex: 0 0 30%;
  }

  .right-button:is(.Desktop, .Tablet) {
    flex: 0 0 68%;
  }

  .right-button:disabled:is(.Desktop, .Tablet) {
    flex: 0 0 68%;
  }

  .separator:is(.Desktop, .Tablet) {
    margin-bottom: 0;
  }

  /* .margin:is(.Desktop, .Tablet) {
      margin-bottom: 10px;
    } */

  .flex_third:is(.Desktop, .Tablet) {
    width: 100%;
  }
}

.inner {
  text-align: center;

  color: var(--Web-Black-High, #212121);
  text-align: center;
  /* Subtitle 1 (Medium) */
  font-family: Outfit;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 20.8px */
}

.container:is(.Mobile) {
  flex-direction: column;
}

.separator .container {
  max-width: none;
}

.content:is(.Mobile) {
  padding: 0;
}

.inner:is(.Mobile) {
  padding: 20px 20px 0 20px;
}

.container:is(.Mobile) {
  flex-direction: column;
  gap: 0;
}

.flex_dropdown:is(.Mobile),
.flex_inputText:is(.Mobile) {
  width: 100%;
}
.flex_half:is(.Mobile) {
  width: 100%;
}

.buttoncontainer:is(.Mobile) {
  gap: 10px;
  margin-bottom: 24px;
}

.left-button:is(.Mobile) {
  flex: 0 0 30%;
}

.right-button:is(.Mobile) {
  flex: 0 0 68%;
}

.right-button:disabled:is(.Mobile) {
  flex: 0 0 68%;
}

.separator:is(.Mobile) {
  margin-bottom: 0;
}

/* .margin:is(.Mobile) {
    margin-bottom: 10px;
  } */

.flex_third:is(.Mobile) {
  width: 30%;
}

.content {
  /* display: flex; */
  justify-content: center;
  margin: 0;
}

.top-up-successful,
.top-up-successful * {
  margin-top: 20px;
  box-sizing: border-box;
}

.top-up-successful {
  color: var(--primary-active, #ac2887);
  text-align: center;
  font: 500 20px/130% "outfit";
  position: relative;
  align-self: stretch;
}

.wallet-limit-up-to-m,
.wallet-limit-up-to-m * {
  box-sizing: border-box;
  margin-top: 16px;
  margin-bottom: 40px;
}

.wallet-limit-up-to-m {
  position: relative;
  align-self: stretch;
  padding: 0 100px;
  color: var(--Web-Black-low, #9e9e9e);
  text-align: center;
  /* Subtitle 1 (Medium) */
  font-family: Outfit;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 20.8px */
}

.wallet-limit-up-to-m:is(.Mobile) {
  padding: 0 30px;
}

.group-208 {
  height: auto;
  position: absolute;
  left: calc(50% - 11px);
  top: calc(50% - 12px);
  overflow: visible;
}

.refNo {
  color: var(--web-black-high, #212121);
  text-align: center;
  font-family: var(--h-3-font-family, "Outfit", sans-serif);
  font-size: var(--h-3-font-size, 18px);
  line-height: var(--h-3-line-height, 130%);
  font-weight: var(--h-3-font-weight, 500);
  position: relative;
  align-self: stretch;
  margin-top: 16px;
}

@media (max-width: 500px) {
}

.inner:is(.Mobile) {
  padding: 20px 20px 0 20px;
}

.popup-sign,
.popup-sign * {
  box-sizing: border-box;
}

.popup-sign {
  background: var(--alert-negative, #df0029);
  border-radius: 60px;
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  position: relative;
  margin: 10px auto 0 auto;
}

.cardImage {
  max-width: 100%;
  max-height: 100%;
  margin: auto;
  display: block;
  object-fit: contain;
  box-shadow: 0px 5px 20px 5px #00000029;
  border-radius: 8px;
}

.cardImgBox {
  width: 240px;
  height: 210px;
  display: flex;
  align-items: center;
  margin: 0 auto 10px auto;
}

.cardBox {
  width: 270px;
  height: 270px;
  margin: auto;
  display: flex;
}

.infoBox {
  width: 280px;
  margin: auto;
}
</style>
